import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { SummaryDarkerItem } from '../SummaryWmo.css'

const WarrantyWmo = props => {
  const { data } = props

  return (
    <Box direction="row" justify="between">
      <SummaryDarkerItem>
        Part Protection:
      </SummaryDarkerItem>

      <SummaryDarkerItem data-testid='cart-summary-cpp'>
        $
        {commaSeparetedValue(parseFloat(data.warrantyTotal))}
      </SummaryDarkerItem>
    </Box>
  )
}

export default WarrantyWmo
